export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-900">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[900px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 font-bold mb-3">
              关于我们
            </h2>
            <p className="text-sm text-foreground-400 max-w-lg mx-auto">
              了解爱看影院的初心与使命
            </p>
          </div>

          <div className="bg-background-800/40 border border-background-700/30 rounded-xl p-8 md:p-10">
            <div className="max-w-2xl mx-auto">
              <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-5">
                爱看影院创立于对影视的热爱。我们深知，每一位影迷都渴望一个<strong className="text-foreground-200">资源丰富、画质清晰、完全免费</strong>的在线观影平台。怀揣这个朴素的心愿，爱看影院应运而生。
              </p>
              <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-5">
                我们拥有专业的内容运营团队，每日精心筛选全网优质<strong className="text-foreground-200">免费电影、免费电视剧、热播综艺和动漫番剧</strong>，确保片库常新、资源齐全。从热门院线大片到冷门经典佳作，从国产精品到海外热剧，力求让每一位访问爱看影院的用户都能找到心仪的作品。
              </p>
              <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-5">
                技术上，我们持续投入播放体验优化，采用先进的CDN加速与智能线路切换，让<strong className="text-foreground-200">高清流畅不缓冲</strong>成为标配。无论您使用电脑、平板还是手机，都能享受一致的优质观影体验。
              </p>
              <p className="text-sm md:text-base text-foreground-300 leading-relaxed">
                爱看影院将始终坚持<strong className="text-primary-400">免费、高清、全面</strong>的核心理念，做影迷心中<strong className="text-foreground-200">最值得信赖的追剧首选平台</strong>。感谢每一位用户的支持与陪伴，让我们一起享受光影世界的无限美好。
              </p>
            </div>

            <div className="mt-8 pt-8 border-t border-background-700/30 flex flex-wrap items-center justify-center gap-8">
              {[
                { num: '5年+', label: '稳定运营' },
                { num: '10万+', label: '影视资源' },
                { num: '50万+', label: '忠实用户' },
                { num: '99.9%', label: '服务可用率' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="font-heading text-xl md:text-2xl text-primary-400 font-bold">{stat.num}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}